var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getSuiClient } from './client';
import { getUserPositionCapId } from 'alphalend-sdk';
export const fetchUserPositionCapId = (network, address) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const suiClient = getSuiClient('mainnet');
        if (!address) {
            return null;
        }
        const id = yield getUserPositionCapId(suiClient, network || 'mainnet', address);
        return id || null;
    }
    catch (error) {
        console.error('Failed to fetch positionCap ID:', error);
        return null;
    }
});
